import {type ReactNode} from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@common-web/components/ui/dialog';
import {Button} from '@common-web/components/ui/button';

export function MemberLifecycleDialogFrame({
  cancelDisabled,
  children,
  contentClassName = 'space-y-4 py-2',
  contentMaxWidthClassName = 'sm:max-w-md',
  description,
  onClose,
  onSubmit,
  open,
  submitDisabled,
  submitLabel,
  submitVariant,
  title,
}: {
  cancelDisabled?: boolean;
  children: ReactNode;
  contentClassName?: string;
  contentMaxWidthClassName?: string;
  description: ReactNode;
  onClose: () => void;
  onSubmit: () => void;
  open: boolean;
  submitDisabled?: boolean;
  submitLabel: ReactNode;
  submitVariant?: 'default' | 'destructive';
  title: ReactNode;
}) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className={contentMaxWidthClassName}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className={contentClassName}>{children}</div>

        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={cancelDisabled}>
            Cancel
          </Button>
          <Button variant={submitVariant} onClick={onSubmit} disabled={submitDisabled}>
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
